import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import assign from 'lodash/assign';
import extend from 'lodash/extend';
import { buildPostAdModel } from '../../../utils/ad_util';
import adsConfig from '../../../server/config/ads';
import { imageSizesLookup } from './../../../utils/cloudinary_asset_util';
import matchMediaDesktop from './../../../utils/client_util';
import Ad from './../../components/ad/ad';
import Analytics from './../../components/analytics/analytics';
import Nav from './../../components/nav/nav';
import navContext from './../../components/nav/nav_data';
import Recirc from './../../components/recirc/recirc';
import Footer from './../../components/footer/footer';
import Config from './../../components/config/config';
import Script from './../../components/head/script';
import featureFlags from '../../../../feature_flags';

class Layout extends Component {
  constructor() {
    super();

    this.hasFooter = true;
  }

  componentDidMount() {
    this.browsiScript();
  }

  livereload() {
    if (this.props.env === 'development') {
      return <script src="//localhost:35729/livereload.js" async />;
    }
    return '';
  }

  scriptbundle() {
    if (this.props.env === 'development') {
      // return <script src="/js/bundle.js" async></script>;
      return <script src="//localhost:3001/static/bundle.js" async />;
    }
    return <script src={`${this.props.staticUrl}/js/bundle.js`} async />;
  }

  browsiScript() {
    if (!matchMediaDesktop() && !document.querySelector('#browsi-tag')) {
      const script = document.createElement('script');
      script.src = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js';
      script.id = 'browsi-tag';
      script.setAttribute('data-pubkey', 'mansueto');
      script.setAttribute('data-sitekey', this.props.site);

      document.querySelector('body').appendChild(script);
    }
  }

  adIframe() {
    // Used by adops to check if js is enabled
    const adSite = this.props.site === 'fastcompany' ? 'fc' : 'fcdesign';
    const iframeSrc = `https://pubads.g.doubleclick.net/gampad/adx?iu=/4160/mv.${adSite}/javascript_disabled&sz=1x1`;
    const innerHtml = `<iframe width="1" height="1" frameBorder="0" scrolling="no" src="${iframeSrc}" />`;

    return <noscript dangerouslySetInnerHTML={{ __html: innerHtml }} />;
  }

  topNavAd(location, site) {
    if (location.pathname !== '/') {
      return null;
    }
    const adData = buildPostAdModel(adsConfig, site, null, 'homepage');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    return (
      <div className="homepage-page__ff-ad-container homepage-page__ff-ad-container--navtop">
        <Ad {...combinedAdModel} name="welcomemat" />
      </div>
    );
  }

  analyticsHeader() {
    // eslint-disable-next-line class-methods-use-this
    const listOfAnalytics = [
      'trackjs',
      'krux',
      'comscore',
      'nielsen',
      'googleAnalytics',
      'facebookPixel'
    ];
    return <Analytics location="header" listOfAnalytics={listOfAnalytics} />;
  }

  analyticsFooter() {
    // eslint-disable-next-line class-methods-use-this
    const listOfAnalytics = [
      'comscore',
      'nielsen',
      'omniture',
      'parsely',
      'structuredData',
      'moatad'
    ];
    return <Analytics location="footer" listOfAnalytics={listOfAnalytics} />;
  }

  postUp() {
    return (
      <Script
        type="text/javascript"
        innerHtml={
          "(function () {window.setTimeout(function() {var e = document.createElement('script'); e.type = 'text/javascript'; e.async = true; e.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.lightboxcdn.com/vendor/252af0a6-c9ae-4612-9dbe-5d1552fad623/lightbox_inline.js?mb=' + (new Date().getTime()); var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);}, 500);})();"
        }
      />
    );
  }

  buildRecircStories(postData, index, currentSite) {
    const post = postData;

    if (index) {
      post.featured_image = {};
    }

    return assign(post, {
      currentSite,
      allowNoImage: index,
      assetSizes: index === 0
        ? imageSizesLookup.bigFirstMobile
        : imageSizesLookup[4]
    });
  }

  render() {
    const { site, location, pageType, recircFeed, config, env } = this.props;
    let activeCategory = '';
    if (this.props.pageType === 'category') {
      activeCategory = location.pathname;
    }
    const hasTopNavAd =
      featureFlags.topNavAdEnabled && location.pathname === '/';

    return (
      <body
        className={`layout ${pageType
          ? `layout--${pageType}`
          : ''} ${hasTopNavAd ? 'layout--has-top-nav' : ''} ${site}`}
      >
        {this.analyticsHeader()}
        {featureFlags.topNavAdEnabled ? this.topNavAd(location, site) : null}
        <Nav
          isHome={location.pathname === '/'}
          activeCategory={activeCategory}
          modifier={site}
          site={site}
          env={env}
          {...navContext[site]}
        />
        <section className="main" role="main">
          {renderRoutes(this.props.route.routes)}
          <Recirc
            currentSite={site}
            env={config.env}
            fastcompany={recircFeed.fastcompany.map((item, index) =>
              this.buildRecircStories(item, index, site)
            )}
            fastcodesign={recircFeed.fastcodesign.map((item, index) =>
              this.buildRecircStories(item, index, site)
            )}
            fastcoexist={recircFeed.fastcoexist.map((item, index) =>
              this.buildRecircStories(item, index, site)
            )}
            fastcocreate={recircFeed.fastcocreate.map((item, index) =>
              this.buildRecircStories(item, index, site)
            )}
          />
        </section>
        <Footer />
        <Config />
        {this.analyticsFooter()}
        {this.livereload()}
        {this.scriptbundle()}
        {this.postUp()}
        {this.adIframe()}
      </body>
    );
  }
}

function mapStateToProps(state) {
  return {
    config: state.config,
    site: state.config.site,
    env: state.config.env,
    staticUrl: state.config.staticUrl,
    pageType: state.context.type || '',
    recircFeed: {
      fastcompany: get(state, 'recircFeed.data.fastcompany') || [],
      fastcodesign: get(state, 'recircFeed.data.fastcodesign') || [],
      fastcocreate: get(state, 'recircFeed.data.fastcocreate') || [],
      fastcoexist: get(state, 'recircFeed.data.fastcoexist') || []
    },
    postFinite: get(state, 'postFinite.data.posts') || []
  };
}

Layout.propTypes = {
  route: PropTypes.shape({
    routes: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  config: PropTypes.shape({}).isRequired,
  env: PropTypes.string.isRequired,
  site: PropTypes.string.isRequired,
  staticUrl: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  location: PropTypes.shape({}).isRequired,
  recircFeed: PropTypes.shape({
    fastcompany: PropTypes.arrayOf(PropTypes.shape({})),
    fastcocreate: PropTypes.arrayOf(PropTypes.shape({})),
    fastcodesign: PropTypes.arrayOf(PropTypes.shape({})),
    fastcoexist: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(Layout));



// WEBPACK FOOTER //
// ./src/views/containers/layouts/layout.js